import { type LoadOptions, RudderAnalytics } from '@rudderstack/analytics-js'
import useRudderStack from '~/composables/useRudderstack'

export default defineNuxtPlugin({
  name: 'rudderstack-plugin',
  parallel: true,
  dependsOn: ['auth0-plugin'],
  setup(nuxtApp) {
    const config = useRuntimeConfig()
    const DATA_PLANE_URL = config.public.RUDDER_STACK.DATA_PLANE_URL
    const WRITE_KEY = config.public.RUDDER_STACK.WRITE_KEY

    const rudderAnalytics = new RudderAnalytics()

    const { identifyUser, ...rest } = useRudderStack(rudderAnalytics)

    const OPTIONS = {
      logLevel: 'DEBUG',
      onLoaded: () => identifyUser(),
    } satisfies LoadOptions

    rudderAnalytics.load(WRITE_KEY, DATA_PLANE_URL, OPTIONS)

    nuxtApp.hook('page:finish', () => {
      rest.trackPageView()
    })

    return {
      provide: {
        rudderstack: rest,
      },
    }
  },
})
